// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"179":"main","736":"vendor"}[chunkId] + "." + {"179":"c38b1470c98aca3f3b8f","736":"4ddce7fe862a15f34c60"}[chunkId] + ".css";
};